"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPadding = void 0;

var _constants = require("../button/constants");

var _constants2 = require("./constants");

var getPadding = function getPadding(theme, isDismissable) {
  if (!isDismissable) {
    return [_constants2.PADDING_VERTICAL, _constants2.PADDING_HORIZONTAL];
  }

  var verticalPadding = Math.min(theme.space[_constants2.PADDING_VERTICAL], _constants.OUTLINE_WIDTH);
  var rightPadding = Math.min(theme.space[_constants2.PADDING_HORIZONTAL], _constants.OUTLINE_WIDTH);
  return [verticalPadding, rightPadding, verticalPadding, _constants2.PADDING_HORIZONTAL];
};

exports.getPadding = getPadding;